<template>
    <v-container fluid>
        <v-row>
            <v-col
                    md="6"
                    offset-md="3">
                <p class="headline text-sm-center">Thank you for trying LOKL!</p>
                <p class="text-sm-center">We appreciate your support. Be sure to check your email for the promo!</p>
                <p class="text-sm-center">Please send any feedback or inquiries to info@trylokl.com</p>
                <div class="text-sm-center">
                    <v-btn large color="warning" class="align-center" :to="{name:'Promos'}">Back to Promos</v-btn>
                </div>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    export default {
        name: "PromoSuccess"
    }
</script>

<style scoped>

</style>